import React, { useEffect, useState } from "react";
import { db } from '../firebase/firebase';
import { ref, onValue } from 'firebase/database';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

function useDynamicScript(url) {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;

        document.body.classList.add('blog')
        document.body.classList.add('logged-in')
        document.body.classList.add('admin-bar')
        document.body.classList.add('wp-embed-responsive')
        document.body.classList.add('customize-support')
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
            document.body.classList.remove('blog')
            document.body.classList.remove('logged-in')
            document.body.classList.remove('admin-bar')
            document.body.classList.remove('wp-embed-responsive')
            document.body.classList.remove('customize-support')
        };
    }, [url]);
}

function extractPreviewData(htmlContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");

    const image = doc.querySelector('img'); // Gets the first <img> element
    const header = doc.querySelector('h1'); // Gets the first <h1> element

    return {
        imageUrl: image ? image.src : null,
        headerText: header ? header.innerText : "No Title"
    };
}

export default function Blog() {
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('blog');
    }, [])

    const [posts, setPosts] = useState([]);
    const [postsAr, setPostsAr] = useState([]);

    useEffect(() => {
        const postsRef = ref(db, 'posts/en');
        const postsRefAr = ref(db, 'posts/ar');
        onValue(postsRef, (snapshot) => {
            const data = snapshot.val();
            const loadedPosts = [];
            if (data) {
                Object.keys(data).forEach(key => {
                    const previewData = extractPreviewData(data[key].content);
                    loadedPosts.push({
                        id: key,
                        content: data[key].content,
                        headerText: data[key].postTitle,
                        imageUrl: data[key].imgPreview,
                        timestamp: new Date(data[key].timestamp).toLocaleString()
                    });
                });
            }
            setPosts(loadedPosts.reverse());
        });

        onValue(postsRefAr, (snapshot) => {
            const data = snapshot.val();
            const loadedPosts = [];
            if (data) {
                Object.keys(data).forEach(key => {
                    const previewData = extractPreviewData(data[key].content);
                    loadedPosts.push({
                        id: key,
                        content: data[key].content,
                        headerText: data[key].postTitle,
                        imageUrl: data[key].imgPreview,
                        timestamp: new Date(data[key].timestamp).toLocaleString()
                    });
                });
            }
            setPostsAr(loadedPosts.reverse());
        });
    }, []);

    return (
        <div>
            <section className="nc min-h-[calc(100vh-80px)] flex flex-col lg:flex-row gap-[50px] justify-center items-center nc px-[20px] lg:px-[100px] py-[50px] lg:py-[5px]">
                <div className="w-full lg:w-[35%] flex flex-col gap-[20px]">
                    <h1 className="text-xl lg:text-3xl 2xl:text-6xl w-3/4 font-bold is-slideup">{t('latest_news')}</h1>

                    <h2 className="text-lg lg:text-xl 2xl:text-2xl border-[2px] border-[#d0a645] text-[#d0a645] py-[10px] px-[20px] lg:px-[80px] rounded-full text-center">{t('news_updates')}</h2>
                    <h2 className="text-lg lg:text-xl 2xl:text-2xl border-[2px] border-[#d0a645] text-[#d0a645] py-[10px] px-[20px] lg:px-[80px] rounded-full text-center">{t('exhibitions')}</h2>
                    <h2 className="text-lg lg:text-xl 2xl:text-2xl border-[2px] border-[#d0a645] text-[#d0a645] py-[10px] px-[20px] lg:px-[80px] rounded-full text-center">{t('press_releases')}</h2>
                </div>
                <div className="w-full lg:w-[60%] flex flex-col items-end gap-2">
                    <div className="w-full flex flex-col lg:flex-row gap-[20px] justify-center">
                        {i18n.language === 'en' ? posts.slice(0, 2).map((post) => (
                            <div onClick={() => navigate(`/blog/${post.id}`)} className="w-[400px] cursor-pointer border-[1px] border-[#d0a645] rounded-[20px] overflow-hidden">
                                <img src={post.imageUrl} className="h-[350px]" alt="" />
                                <div className="h-[200px] p-[20px] flex flex-col gap-[20px]">
                                    <h1 className="text-xl lg:text-2xl 2xl:text-3xl uppercase">{`${post.headerText.slice(0, 30)}...`}</h1>
                                    <h2 className="text-end uppercase underline">{t('read')}
                                        <span>{i18n.language === 'en' ? <ArrowForward /> : <ArrowBack />}</span>
                                    </h2>
                                </div>
                            </div>
                        )) :
                            postsAr.slice(0, 2).map((post) => (
                                <div onClick={() => navigate(`/blog/${post.id}`)} className="w-[400px] cursor-pointer border-[1px] border-[#d0a645] rounded-[20px] overflow-hidden">
                                    <img src={post.imageUrl} className="h-[350px]" alt="" />
                                    <div className="h-[200px] p-[20px] flex flex-col gap-[20px]">
                                        <h1 className="text-xl lg:text-2xl 2xl:text-3xl uppercase">{`${post.headerText.slice(0, 30)}...`}</h1>
                                        <h2 className="text-end uppercase underline">{t('read')}
                                            <span>{i18n.language === 'en' ? <ArrowForward /> : <ArrowBack />}</span>
                                        </h2>
                                    </div>
                                </div>
                            ))}
                    </div>
                    <Link to='/all-posts' className="me-10 bg-[#201B57] text-white hover:text-[#201B57] hover:bg-[#d0a645] transition-all duration-300 px-4 py-1 rounded-md">View All</Link>
                </div>
            </section>
        </div>
    )
}